export default __webpack_public_path__ + "static/media/51.5fa7e052.jpg";